import { Controller } from "stimulus";
import { FloatingMenu } from "utils/floating_menu";

// The newsletter picker in the post editor's header (see Block::PostNewsletterComponent). Choosing a newsletter
// puts its id in the hidden post[newsletter_id] field and fires input + change on it, which is what makes
// auto-save send it. The panel closes on a choice.
export default class extends Controller {
  static targets = ["trigger", "panel", "field"];

  connect() {
    // The newsletter the server last accepted, which a refused choice goes back to.
    this.savedId = this.fieldTarget.value;
    this.floatingMenu = new FloatingMenu({ menu: this.panelTarget, anchor: this.triggerTarget });
  }

  disconnect() {
    this.floatingMenu?.disconnect();
  }

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) this.open();
    else this.close();
  }

  open() {
    this.panelTarget.classList.remove("hidden");
    this.floatingMenu.open();
    this.triggerTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.panelTarget.classList.add("hidden");
    this.floatingMenu.close();
    this.triggerTarget.setAttribute("aria-expanded", "false");
  }

  // The panel stays inside this element in the DOM, so a click in it is not "outside".
  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  choose(event) {
    const radio = event.target;
    if (radio.value !== this.fieldTarget.value) {
      this.show(radio);
      this.fieldTarget.dispatchEvent(new Event("input", { bubbles: true }));
      this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
    this.close();
  }

  // Auto-save accepted the choice.
  saved() {
    this.savedId = this.fieldTarget.value;
  }

  // The server refused the move: put the badge, the radio and the field back to the saved newsletter. Cancelling
  // the event tells auto-save the change is gone, so nothing is left to re-send.
  failed(event) {
    event.preventDefault();
    const radio = this.element.querySelector(`input[type=radio][value="${this.savedId}"]`);
    if (radio) {
      radio.checked = true;
      this.show(radio);
    }
  }

  // The badge, the aria-label and the hidden field follow the chosen radio.
  show(radio) {
    this.fieldTarget.value = radio.value;
    this.triggerTarget.querySelector("[data-newsletter-name]").textContent = radio.dataset.title;
    this.triggerTarget.querySelector("[data-newsletter-dot]")?.style.setProperty("background-color", radio.dataset.color);
    this.triggerTarget.setAttribute("aria-label", `Newsletter: ${radio.dataset.title}`);
  }
}
